var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 3.66667V9C3.33341 9.35362 3.47389 9.69276 3.72394 9.94281C3.97399 10.1929 4.31313 10.3333 4.66675 10.3333H8.66675M3.33341 3.66667V2.33333C3.33341 1.97971 3.47389 1.64057 3.72394 1.39052C3.97399 1.14048 4.31313 1 4.66675 1H7.72408C7.90088 1.00004 8.07042 1.0703 8.19542 1.19533L11.1381 4.138C11.2631 4.26299 11.3334 4.43254 11.3334 4.60933V9C11.3334 9.35362 11.1929 9.69276 10.9429 9.94281C10.6928 10.1929 10.3537 10.3333 10.0001 10.3333H8.66675M3.33341 3.66667H2.00008C1.64646 3.66667 1.30732 3.80714 1.05727 4.05719C0.807224 4.30724 0.666748 4.64638 0.666748 5V11.6667C0.666748 12.0203 0.807224 12.3594 1.05727 12.6095C1.30732 12.8595 1.64646 13 2.00008 13H7.33341C7.68704 13 8.02618 12.8595 8.27622 12.6095C8.52627 12.3594 8.66675 12.0203 8.66675 11.6667V10.3333",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/copy-2.87e439a7cc286be9d40971bbb64a31a5.svg";
export { ForwardRef as ReactComponent };